import { render, staticRenderFns } from "./PlayerVideotag.vue?vue&type=template&id=030e57e6&"
import script from "./PlayerVideotag.vue?vue&type=script&lang=js&"
export * from "./PlayerVideotag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports